import { Component, Vue } from 'vue-property-decorator';
import { AuthentificationService } from '@/services';
import router from '@/router';
import { UserProfileStore } from '@/store/store.userProfile';
import { LoggerService } from '@/utils';
import { InitializingStatusEnums } from '@/enums/InitializingStatusEnums';

@Component
export default class LoginComponent extends Vue {
    public lodaingOverlay: boolean = true;

    // tslint:disable-next-line: no-empty
    public mounted() {
        if (AuthentificationService.GetAuthentificationServiceStaus() !== InitializingStatusEnums.INITIALIZED) {
            AuthentificationService.InitAuthentificationService();
        }
        AuthentificationService.GetUserManager().clearStaleState(); // remove expired tokens from storage
        if (this.$route.params.idToken) {
            // login
            const url = encodeURI(`${window.location.origin}/#${this.$route.params.idToken}`);
            AuthentificationService.SignInRedirectCallback(url);
        } else if (this.$route.params.refreshToken) {
            // silent refresh token
            // const url = `${window.location.origin}/#${this.$route.params.refreshToken.replace(/\s/g, '%20')}`;
            const url = encodeURI(`${window.location.origin}/#${this.$route.params.refreshToken}`);
            AuthentificationService.SigninSilentCallback(url);
        } else if (this.$route.params.logoutParams) {
            // logout
        } else {
            AuthentificationService.GetUser()
                .then((user) => {
                    LoggerService.LogDebug(`user: ${user}`);
                    if (user != null && user.profile.sub) {
                        UserProfileStore.FetchUserProfile(user.profile.sub)
                            .then((data) => {
                                LoggerService.LogDebug('user data: ', data);
                            }).catch((error) => {
                                LoggerService.LogError('user error: ', error);
                            });
                    }
                    router.push('/');
                })
                .catch((error) => {
                    LoggerService.LogError('user error: ', error);
                    router.push('/');
                });
        }
    }

    public login() {
        const t = 0;
    }
}
